import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DistrictAdministrationService } from "../../services/districtadministration.service";
import { ChangeSchoolRequestModel } from "../shared/ChangeSchoolRequestModel";
import { FacilityAssignComponent } from "../shared/facility-assign/facility-assign.component";

@Component({
	selector: "app-district-edit-school",
	templateUrl: "./district-edit-school.component.html",
	styleUrls: ["./district-edit-school.component.css"],
})
export class DistrictEditSchoolComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private districtadministrationService: DistrictAdministrationService,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadSchoolData();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	user: any;

	SchoolID: any;
	SchoolName: any;
	SchoolNumber: any;
	Phone: any;
	Street: any;
	City: any;
	State: any;
	Zip: any;
	DistrictID: any;

	SchoolTypeID: any;
	lstSchoolTypes: any = [];

	schoolData: any;

	errorMessage: any = "";

	OriginalSchoolNumber: any;

	@ViewChild(FacilityAssignComponent)
	facilityAssignComp: FacilityAssignComponent;
	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////
	loadSchoolData() {
		var result = this.districtadministrationService.SchoolSelect(this.SchoolID);
		result.subscribe(
			(response) => {
				this.schoolData = response[0];

				this.SchoolName = this.schoolData.SchoolName;
				this.SchoolNumber = String(this.schoolData.SchoolNumber);
				this.OriginalSchoolNumber = String(this.schoolData.SchoolNumber);
				this.Phone = this.schoolData.Phone;
				this.Street = this.schoolData.Street;
				this.City = this.schoolData.City;
				this.State = this.schoolData.State;
				this.Zip = this.schoolData.Zip;

				this.DistrictID = this.schoolData.DistrictID;

				this.loadSchoolTypes();
			},
			(error) => {}
		);
	}

	loadSchoolTypes() {
		var result = this.districtadministrationService.LoadSchoolTypes();
		result.subscribe(
			(response) => {
				this.lstSchoolTypes = response;

				this.SchoolTypeID = this.lstSchoolTypes[0].SchoolTypeID;
				if (this.schoolData.SchoolTypeID != undefined) {
					this.SchoolTypeID = this.schoolData.SchoolTypeID;
				}
			},
			(error) => {}
		);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";
		/////////////////////
		//Error handling
		/////////////////////
		if (this.SchoolName == "") {
			this.errorMessage = "Please enter a school name";
		}

		if (String(this.SchoolNumber) != String(this.OriginalSchoolNumber)) {
			var Msg: string = "";

			Msg =
				`You are about to change this school's number from "` +
				this.OriginalSchoolNumber +
				`" to "` +
				this.SchoolNumber +
				`". Are you sure you want to continue? NOTE: ` +
				`This can cause IMPORT TO ERROR if the filenames don't match.` +
				` Please Check with Development before making this change.`;

			this.confirmationService.confirm({
				key: "EditConfirm",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: Msg,
				header: "Confirm Change School Number",
				icon: "fa",
				accept: () => {
					this.onFinishUpdate();
				},
			});
		} else {
			this.onFinishUpdate();
		}

		/////////////////////
	}

	onFinishUpdate() {
		let lstFacilityID: number[] = [];

		var FacilityData = this.facilityAssignComp.lstFacility;
		for (var i = 0; i < FacilityData.length; i++) {
			lstFacilityID = [...lstFacilityID, FacilityData[i].FacilityID];
		}

		//Create Request Model
		let parms: ChangeSchoolRequestModel = {
			SchoolID: this.SchoolID,
			SchoolName: this.SchoolName,
			DistrictID: this.DistrictID,
			SchoolNumber: this.SchoolNumber,
			Phone: this.Phone,
			Street: this.Street,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			SchoolTypeID: this.SchoolTypeID,
			FacilityIDs: lstFacilityID,
		};

		var result = this.districtadministrationService.UpdateSchool(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "Edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "Edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the school",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////

	IsSuperUser() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}
}
